import "./Navigation.css";
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useState } from "react";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import MenuIcon from '@mui/icons-material/Menu';
import ShareIcon from '@mui/icons-material/Share';
import logo from "./pictures/styclick.png"

export default function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  return (
    <nav className="navigation">
      <a href="/" className="brand-name">
        <img style={{width: "3rem", height:"auto"}} src={logo} alt="logo"/>
      </a>
      <button
        className="hamburger"
        onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}
      >
        {/* icon from heroicons.com */}
    
        <MenuIcon color="white"></MenuIcon>
      </button>
      <div className="links">
        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }
        >
          <ul>
            <li>
              <a className="icon-button" href="#">Chat&nbsp;<ChatBubbleIcon></ChatBubbleIcon></a>
            </li>

            <li>
              <a className="icon-button" href="/catalogue">Catalogue&nbsp;<CheckroomIcon></CheckroomIcon></a>
            </li>
            <li>
              <a className="icon-button" href="/diary">Diary&nbsp; <AutoStoriesIcon></AutoStoriesIcon></a>
            </li>
            <li>
              <a className="icon-button" href="/refer">Refer&nbsp;<ShareIcon></ShareIcon></a>
            </li>
          </ul>
        </div>
        <div className="commerce">
         <a className="icon-button" href="/wallet"> &nbsp; <AccountBalanceWalletIcon ></AccountBalanceWalletIcon></a>
          <a className="icon-button" href="#"><ShoppingCartIcon></ShoppingCartIcon></a>
        </div>
      </div>
    </nav>
  );
}
